module.exports = __webpack_public_path__ + "static/media/banner-clients-06-mobile.066f193e.jpg";